export default __webpack_public_path__ + "static/media/hs1french.8e2df681.png";